import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {useWorkspace} from '../hooks/useWorkspace';

const {FiPrinter, FiX, FiCheckCircle, FiFileText} = FiIcons;

export default function QuotationModal({plan, onClose}) {
  const {business, brandProfile} = useWorkspace();

  if (!plan) return null;

  const quoteRef = `QT-2026-${String(plan.id).replace(/[^a-zA-Z0-9]/g, '').slice(-5).toUpperCase()}`;
  const quoteDate = plan.created ? plan.created.slice(0, 10) : new Date().toISOString().slice(0, 10);
  const expiryDate = new Date(Date.now() + 30 * 86400000).toISOString().slice(0, 10);

  const deliverables = plan.content?.deliverables || [
    `Strategic Execution: ${plan.title}`,
    'Specialist bot review and quality assurance',
    'Implementation guidance and milestone tracking'
  ];

  const estimatedFee = plan.content?.fee || 3850;

  function handlePrint() {
    window.print();
  }

  return (
    <div className="add-page-modal-backdrop quotation-backdrop" onClick={onClose} role="presentation">
      <div
        className="add-page-dialog quote-modal-dialog"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Quotation preview"
      >
        {/* Action bar — hidden when printing */}
        <div className="quotation-actions">
          <div className="inline">
            <SafeIcon icon={FiFileText} />
            <b>Client Quotation Export</b>
          </div>
          <div className="inline">
            <button type="button" className="button primary compact" onClick={handlePrint}>
              <SafeIcon icon={FiPrinter} />
              Print / Save PDF
            </button>
            <button type="button" className="icon-button" onClick={onClose} aria-label="Close">
              <SafeIcon icon={FiX} />
            </button>
          </div>
        </div>

        {/* Printable Quotation Body — the only thing on the printed page */}
        <div className="quotation-print-sheet">
          <div className="quotation-head">
            <div>
              <h2 className="quotation-business">{business.name || 'Northstar Studio'}</h2>
              <small className="muted">{business.industry || 'Business Services'}</small>
              {brandProfile?.principles?.length > 0 && (
                <p className="quotation-principles">Principles: {brandProfile.principles.join(' · ')}</p>
              )}
            </div>
            <div className="quotation-meta">
              <span className="status approved">Official Quote</span>
              <div><b>Ref:</b> {quoteRef}</div>
              <div><b>Date:</b> {quoteDate}</div>
              <div><b>Valid until:</b> {expiryDate}</div>
            </div>
          </div>

          <div className="quotation-scope">
            <small className="eyebrow">Engagement Scope</small>
            <h3>{plan.title}</h3>
            <p className="muted">{plan.content?.summary || 'Produced and synthesized by dedicated AI specialists in workspace command center.'}</p>
          </div>

          <table className="quotation-table">
            <thead>
              <tr>
                <th>Deliverable / Scope Item</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {deliverables.map((item, idx) => (
                <tr key={idx}>
                  <td>
                    <span className="inline">
                      <SafeIcon icon={FiCheckCircle} />
                      <span>{item}</span>
                    </span>
                  </td>
                  <td><small className="muted">Included</small></td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="quotation-total">
            <div>
              <b>Total Estimated Investment</b>
              <small className="muted quotation-total-note">Subject to standard terms of engagement</small>
            </div>
            <div className="quotation-total-amount">
              ${estimatedFee.toLocaleString()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
